import React from 'react'
import { Container } from 'react-bootstrap'
import withStyles from 'isomorphic-style-loader/withStyles';
import Skeleton from '../../../Common/Skeleton/Skeleton'
import s from './HomeSkeleton.css'

function HomeSkeleton() {
  return (
    <div className={s.homeSkeletonContainer}>
      <Container>
        <div className={s.homeSkeletonWrapper}>
          <div className={s.homeSkeletonLsContainer}>
            <Skeleton className={s.homeSkeletonHeading} />
            <Skeleton className={s.homeSkeletonPara1} />
            <Skeleton className={s.homeSkeletonPara2} />
          </div>
          <div className={s.homeSkeletonImgWrapper}>
            <Skeleton className={s.homeSkeletonImg} />
          </div>
        </div>
      </Container>
    </div>
  )
}

export default withStyles(s)(HomeSkeleton);
